import React from 'react';

/**
 * Per-board placeholder silhouette, shown when there is no image OR when the
 * image fails to load (D4). Keyed by board category:
 *   numismatic-paper-money → currency-note rectangle
 *   numismatic-coins       → circular coin
 *   sports-cards / default → trading-card rounded rectangle
 */
const Silhouette: React.FC<{ boardCategory: string | null }> = ({ boardCategory }) => {
  const common = 'w-40 h-56 rounded bg-white border border-dashed border-gray-300 flex items-center justify-center text-gray-300';

  if (boardCategory === 'numismatic-coins') {
    return (
      <div className={common} aria-hidden="true">
        <svg viewBox="0 0 24 24" className="w-16 h-16" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="5.5" />
        </svg>
      </div>
    );
  }

  if (boardCategory === 'numismatic-paper-money') {
    return (
      <div className={common} aria-hidden="true">
        <svg viewBox="0 0 24 24" className="w-20 h-20" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="2.5" y="7" width="19" height="10" rx="1" />
          <circle cx="12" cy="12" r="2.5" />
          <line x1="5" y1="9.5" x2="5" y2="14.5" />
          <line x1="19" y1="9.5" x2="19" y2="14.5" />
        </svg>
      </div>
    );
  }

  // sports-cards / default → trading-card silhouette
  return (
    <div className={common} aria-hidden="true">
      <svg viewBox="0 0 24 24" className="w-16 h-16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="6" y="3" width="12" height="18" rx="1.5" />
        <circle cx="12" cy="9" r="2.5" />
        <path d="M8 17c0-2.2 1.8-3.5 4-3.5s4 1.3 4 3.5" />
      </svg>
    </div>
  );
};

export default Silhouette;
